import { persistor } from './store';

// createBrowserRouter() calls router.initialize() at module-eval time, so the
// initial route's loader runs before redux-persist has rehydrated persisted
// slices (studyContext, blocks, todaySession, ...). Loaders that read
// persisted state must await this first or a hard refresh sees pristine state
// (ORA-43: refreshing a self-assessment review rendered a blank exam screen).
export const waitForRehydration = (): Promise<void> =>
  new Promise((resolve) => {
    if (persistor.getState().bootstrapped) {
      resolve();
      return;
    }

    const unsubscribe = persistor.subscribe(() => {
      if (persistor.getState().bootstrapped) {
        unsubscribe();
        resolve();
      }
    });
  });
